<!--
  多选入口 传入 topicId 默认为 10
  /web/seckill-public?multipleTopicId=85
  /web/topic-detail?topicId=88&buyFlag=1
-->

<template>
  <div ref="seckill_ref" class="seckill">
    <BudoNoticeBar confKey="index_v3_notice" />

    <van-tabs v-if="cateNameList && cateNameList.length > 0" v-model="cateName" animated type="card"
      @click="onTabClick">
      <van-tab v-for="(name, index) of cateNameList" :key="index" :name="name" :title="name">
      </van-tab>
    </van-tabs>

    <van-list ref="goods_list_ref" v-model="loading" :finished="finished" :finished-text="finishedText"
      :immediate-check="false" :offset="100" @load="on_list_load">
      <div>
        <div v-for="(item, index) in goodsList" :key="index">
          <div class="topic_multiple budo-18">
            <van-card :thumb="item.headImage ||
              'https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/flf2dac3qmz9zw2ixui6enls.png'
              " @click="goGoodsDetail(item)">
              <template #title>
                <div class="van-card__title">
                  <div class="goods-name">
                    <van-tag v-for="tag in JSON.parse(item.tags)" :key="tag" color="#f55519" size="medium" style="
                        display: block;
                        float: left;
                        margin-top: 6px;
                        margin-right: 4px;
                      ">{{ tag }}</van-tag>
                    <span>{{ item.name }}</span>
                  </div>

                  <span v-if="topic.visiblePrice" class="goods-price">{{
                    item.price | money
                    }}</span>
                </div>
              </template>
            </van-card>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import BudoNoticeBar from "@/components/BudoNoticeBar.vue";
import { getMultipleGoodsByPublic } from "@/api/goods-api";

const PAGE_SIZE = 200

export default {
  name: "seckill",

  components: { BudoNoticeBar },

  data() {
    return {
      topic: {},

      goodsList: [],
      cateNameList: [],
      visibleSpecWin: false,
      goodsDetail: {},
      visiblePrice: 1,
      error: false,
      loading: false,
      finished: false,
      finishedText: "",
      cateName: "",
      pi: 0,
      haveData: true,
      timerId: -1,
    };
  },

  created() {
    this.initGoodsList();
  },

  methods: {
    on_list_load() {
      console.log("#80 on_list_load")

      this.getGoodsList()
    },

    goGoodsDetail(item) {
      if (this.topic?.canBuy) {
        this.$router.push({
          path: "goods-detail",
          query: {
            goodsId: item.goodsId,
            topicId: this.$route.query.multipleTopicId,
          },
        });
        return;
      }

      this.$router.push({
        path: "seckill-goods-detail",
        query: { goodsId: item.goodsId },
      });
    },

    initGoodsList() {
      getMultipleGoodsByPublic(
        1,
        PAGE_SIZE,
        this.cateName,
        this.$route.query.multipleTopicId
      ).then((res) => {
        var bg_url = res.data.bg_url;

        this.$refs.seckill_ref.style.background = "url(" + bg_url + ")";
        this.$refs.seckill_ref.style.backgroundRepeat = "no-repeat";
        this.$refs.seckill_ref.style.backgroundSize = "100% auto";
        this.$refs.seckill_ref.style.backgroundColor = "#c9c4c4";

        this.cateNameList = res.data.cates || ['全部商品'];
        this.topic = res.data.topic;

        if (this.cateNameList && this.cateNameList.length > 0) {
          this.cateName = this.cateNameList[0];
          this.goodsList = res.data.goods.records;
          this.finished = false;
        }
      });

      this.pi = 1;
    },

    onTabClick(name) {
      budo_log.info("#119 onTabClick", name);

      this.pi = 0;
      this.cateName = name;
      this.goodsList = [];

      this.loading = true;
      this.finished = false;
      if (this.cateNameList && this.cateNameList.length > 0) {
        this.getGoodsList();
      }
    },

    getGoodsList() {
      if (this.cateNameList && this.cateNameList.length > 0) {
        this.finishedText = "加载中 E ...";
        budo_log.info("#134", this.pi);
        this.pi++;

        // 促销标签商品
        getMultipleGoodsByPublic(
          this.pi,
          PAGE_SIZE,
          this.cateName,
          this.$route.query.multipleTopicId
        ).then((res) => {
            if (!res.data) {
              this.loading = false;
              this.finished = true;
              this.haveData = false;
              return;
            }

            budo_log.info("#146 getMultipleGoodsByPublic", res);
            this.goodsList = this.goodsList.concat(res.data.goods.records);

            if (this.goodsList.length >= res.data.goods.total) {
              this.finishedText = "没有更多了 O";
              this.finished = true;
            }

            if (res.data.total === 0) {
              this.finishedText = "看看其它的吧 F";
              this.finished = true;
            }

            this.loading = false;
          })
          .catch((error) => {
            budo_log.info("#138 error=", error);

            this.finishedText = "没有更多了 P";
            this.finished = true;
            this.loading = false;
            this.error = true;
          });
      } else {
        this.loading = false;
        this.finished = true;
      }
    },

    handleClick(val) {
      this.$router.replace({ path: `/seckill-detail?goodsId=${val.id}` });
    },

    doScroll() {
      if (this.timerId) clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        // 获取页面滚动距离之后设置给当前路由的元信息
        this.$route.meta.y = window.pageYOffset;
        budo_log.info("#190", window.pageYOffset);
      }, 300);
    },
  },

  mounted() {
    window.onscroll = this.doScroll;
  },
};
</script>

<style lang="scss" scoped>
.goods-price {
  font-size: 14px;

  color: #ffffff;
  background: #ff0000d7;

  position: absolute;
  bottom: 0;
  right: 0;

  border-radius: 5px;
  padding: 1px 2px;
}

.seckill {
  min-height: 100vh;
  padding: 300px 20px 70px;

  .goods-name {
    font-size: 15px;
    font-weight: 500;
    color: #0a0a0a;
    line-height: 32px;
    text-align: left;
  }

  .van-card {
    margin-top: 8px;
    border-radius: 10px;

    .van-card__title {
      font-size: 16px;
    }

    .van-card__desc {
      margin: 10px 0;
      color: #808080;
    }

    .target {
      color: #ff4200;
      background: #ffe5dc;
      padding: 5px 7px;
    }

    .van-card__footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 88px;
    }

    .price-icon {
      width: 18px;
      height: 18px;
      margin-right: 1px;
    }

    .van-button--small {
      padding: 0 15px;
    }

    .van-icon-cart-o {
      font-size: 14px;
      float: left;
      margin-right: 5px;
    }
  }
}
</style>
